import { Component, Input } from '@angular/core';
import { GraphContainer } from 'src/app/model/generic-graph';

@Component({
  selector: 'app-financial-kpi',
  templateUrl: './financial-kpi.component.html',
  styleUrls: ['./financial-kpi.component.scss']
})
export class FinancialKpiComponent {
  @Input() graphData!: GraphContainer;
}
